import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HotjarService {
  /** True only when the Hotjar tracking script has installed window.hj. */
  get isEnabled(): boolean {
    return typeof window !== 'undefined' && typeof window.hj === 'function';
  }

  /** Identifies the current user to Hotjar. Guarded and error-isolated so analytics never breaks the app. */
  identify(userId: string, attributes?: Record<string, string | number | boolean>): void {
    if (!this.isEnabled) return;
    try {
      window.hj!('identify', userId, attributes);
    } catch {
      /* analytics failures must never surface to the user */
    }
  }
}
